import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';

export const useAppIsReady = () => {
  const isAuth = useIsAuthenticated();
  const { inProgress } = useMsal();

  return isAuth && inProgress === InteractionStatus.None;
};
